import { render, staticRenderFns } from "./LineProduct.vue?vue&type=template&id=13537a86"
import script from "./LineProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./LineProduct.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports